import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import Events from '@/hooks/events';
import actions from '../constants';

const useRefreshTasks = (category) => {
  const handler = useDispatch();
  return useCallback(({ page }) => handler({
    type: actions.REFRESH_REQUEST_TASKS, category, page,
  }), [category]);
};

const useFetchRequestTasks = (category) => {
  const handler = useDispatch();
  return useCallback(({
    append, page, pageSize,
  }) => handler({
    type: actions.FETCH_REQUEST_TASKS, category, append, page, pageSize,
  }), [category]);
};

const useUpdateTasksFilter = (category) => {
  const handler = useDispatch();
  return useCallback(({ value }) => handler({
    type: actions.UPDATE_REQUEST_TASKS_FILTER, category, value,
  }), [category]);
};

const useUpdateTasksViewFilter = (category) => {
  const handler = useDispatch();
  return useCallback(({ view }) => handler({
    type: actions.UPDATE_REQUEST_TASKS_VIEW_FILTER, category, view,
  }), [category]);
};

const useToggleTaskColumnOrderBy = (category) => {
  const handler = useDispatch();
  return useCallback(({ orderByColumn }) => handler({
    type: actions.TOGGLE_REQUEST_TASK_COLUMN_ORDER_BY, category, orderByColumn,
  }), [category]);
};

const useToggleTasksPresentation = (category) => {
  const handler = useDispatch();
  return useCallback(({ display }) => handler({
    type: actions.TOGGLE_REQUEST_TASKS_PRESENTATION, category, display,
  }), [category]);
};

const useUpdateTaskFormProperties = () => {
  const handler = useDispatch();
  return useCallback(({
    properties, fields, entity, template,
  }) => handler({
    type: actions.UPDATE_REQUEST_TASK_FORM_PROPERTIES,
    properties,
    fields,
    entity,
    template,
  }), []);
};

const useEditTask = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ template }) => handler({
    type: actions.EDIT_REQUEST_TASK, category, code, template,
  }), [category, code]);
};

const useUpdateActiveTaskTab = () => {
  const handler = useDispatch();
  return useCallback(({ step }) => handler({
    type: actions.UPDATE_REQUEST_TASK_TAB, step,
  }), []);
};

const useShowRequestTask = () => {
  const handler = useDispatch();
  return useCallback(({ task }) => handler({
    type: actions.SHOW_REQUEST_TASK, task,
  }), []);
};

const useShowManageRequestTask = () => {
  const handler = useDispatch();
  return useCallback(({ task }) => handler({
    type: actions.SHOW_MANAGE_REQUEST_TASK, task,
  }), []);
};

const useClaimRequestTask = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ name, silent }) => handler({
    type: actions.CLAIM_REQUEST_TASK, category, code, name, silent,
  }), [category, code]);
};

const useUpdateActiveTaskProperties = () => {
  const handler = useDispatch();
  return useCallback(({ properties }) => handler({
    type: actions.UPDATE_ACTIVE_TASK_PROPERTIES, properties,
  }), []);
};

const useUpdateManageTaskProperties = () => {
  const handler = useDispatch();
  return useCallback(({ properties }) => handler({
    type: actions.UPDATE_MANAGE_TASK_PROPERTIES, properties,
  }), []);
};

export default {
  useCompleteRequestTask: () => Events.useSimpleDispatch(actions.COMPLETE_REQUEST_TASK),
  useEditTask,
  useFetchRequestTasks,
  useHideManageTask: () => Events.useSimpleDispatch(actions.HIDE_MANAGE_TASK),
  useHideRequestTask: () => Events.useSimpleDispatch(actions.HIDE_REQUEST_TASK),
  useManageRequestTask: () => Events.useSimpleDispatch(actions.MANAGE_REQUEST_TASK),
  useRefreshTasks,
  useSaveRequestTask: () => Events.useSimpleDispatch(actions.SAVE_REQUEST_TASK),
  useShowManageRequestTask,
  useShowRequestTask,
  useToggleTaskColumnOrderBy,
  useToggleTasksPresentation,
  useUpdateActiveTaskTab,
  useClaimRequestTask,
  useUpdateActiveTaskProperties,
  useUpdateManageTaskProperties,
  useUpdateTaskFormProperties,
  useUpdateTasksFilter,
  useUpdateTasksViewFilter,
};
